// src/pages/Tienda.js
import React from 'react';

function Tienda() {
  return (
    <div className="min-h-screen bg-toyo-black text-white">
      <section className="container mx-auto px-4 py-20">
        <h1 className="text-4xl font-display mb-6">TIENDA</h1>
        <p className="text-xl">Próximamente...</p>
      </section>
    </div>
  );
}

export default Tienda;